import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import apiClient from "../../apiClient";
import { DELETE_ROLE, USER_ROLES } from "../../apiClient/apiEndpoints";
import { debounce, formatDataForTable, modalName } from "../../utils/general";
import UserRoleSkelton from "../../components/Skeleton/UserRoleSkelton";
import NoDataFound from "../../components/NoDataFound";
import { useModalContext } from "../../modal/context/ModalProvider";
import { UserIcon } from "../../Icons";
import { RightDragIcon } from "../../assets/Icons";

const { Table } = UiComponents;
const { useUnoSelector } = UnoStoreHooks;

const tableHeaders = [{ title: "User Roles" }, { title: "Description" }, { title: "Users" }, { title: "View" }];

const RolesList = ({ isMobileView }) => {
  const navigate = useNavigate();
  const { openModal, closeModal } = useModalContext();
  const configData = useUnoSelector((state) => state.config);
  const userData = useUnoSelector((state) => state.user);
  const [roleList, setRoleList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tableRows, setTableRows] = useState([{ cellData: [] }]);

  const handleOpenConfirmRoleDeleteRole = async (list, id) => {
    openModal({
      modalName: modalName.CONFIRM_BOX,
      title: "Delete Role",
      message: "Are you sure to delete this role.",
      confirmBtnName: "Confirm",
      handleConfirmClick: () => handleDebounceDeleteRole(list, id),
    });
  };

  const handleDebounceDeleteRole = async (list, id) => {
    try {
      let newRoleList = list.map((item) => (item.id === id ? { ...item, deleteLoading: true } : item));
      setRoleList(newRoleList);
      const formattedRows = formatDataForTable(newRoleList, navigate, handleOpenConfirmRoleDeleteRole);
      setTableRows(formattedRows);
      closeModal();
      await apiClient.post(`${configData.config.UNO_URL}${DELETE_ROLE}`, { id: id });
      getRoleList();
    } catch (error) {
      console.log(error);
    }
  };

  const getRoleList = async () => {
    try {
      setLoading(true);
      let data = await apiClient.get(`${configData.config.UNO_URL}${USER_ROLES}/${userData.user.group.typeId}`);
      let list = data.map((item) => ({ ...item, deleteLoading: false }));
      setRoleList(list);
      const formattedRows = formatDataForTable(list, navigate, handleOpenConfirmRoleDeleteRole);
      setTableRows(formattedRows);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getRoleList();
  }, []);


  return (
    <>
      {!isMobileView ? (
        <>
            {loading ? (
              <UserRoleSkelton header={tableHeaders} />
            ) : tableRows.length > 0 ? (
              <Table tableHeaders={tableHeaders} tableRows={tableRows} tableClass="table-striped table-bordered" />
            ) : (
              <NoDataFound headText="No Data Found." />
            )}
        </>
        ) : (
        <>
            <div className="roleCate-parent">
              {roleList.map((role) =>(
                  <div className="roleCate-item" onClick={() => navigate(`/roles/permission/view/${role.id}`)}>
                    <h5>{role.name}</h5>
                    {role.name === "User" && <p>Role with user level permissions</p>}
                    <div className="numUse">
                      <span className="useNum">
                        <UserIcon />
                       {role.assignedUsers}
                      </span>
                      <span className="enter">
                        <RightDragIcon />
                      </span>
                    </div>
                  </div>
              ))}

            </div>
        </>
      )}
    </>
  );
};

export default RolesList;